import { sort } from '~/support/utils';

import ApiBase from './ApiBase';

export const CHANNELS_ENDPOINT = 'channels';
export const EMAIL_PREFERENCES = 'email-preferences';
export const RULES_ENDPOINT = 'rules';
export const TOGGLE = 'toggle';

export default class NotificationsService extends ApiBase {
  async applyRuleToAssociatedDatasets(datasetId, payload) {
    const { data } = await this.client.put(`/${RULES_ENDPOINT}/datasets/${datasetId}/all-associated`, payload);

    return data;
  }

  async createChannel(payload) {
    const { data } = await this.client.post(`/${CHANNELS_ENDPOINT}`, payload);

    return data;
  }

  async createRule(payload) {
    const { data } = await this.client.post(`/${RULES_ENDPOINT}`, payload);

    return data;
  }

  async deleteChannel(id) {
    const { data } = await this.client.delete(`/${CHANNELS_ENDPOINT}/${id}`);

    return data;
  }

  async deleteRule(id) {
    const { data } = await this.client.delete(`/${RULES_ENDPOINT}/${id}`);

    return data;
  }

  async fetchChannels(method = '') {
    const { data } = await this.client.get(`/${CHANNELS_ENDPOINT}`, { params: { method } });

    return data;
  }

  async fetchEmailPreferences() {
    const { data } = await this.client.get(`/${EMAIL_PREFERENCES}`);

    return data;
  }

  async fetchRules({ orgId, pageToken, query, sortSettings }) {
    const params = { orgId, pageToken, query, sort: sort.stringify(sortSettings) };
    const { data } = await this.client.get(`/${RULES_ENDPOINT}`, { params });

    return data;
  }

  async fetchRule(id) {
    const { data } = await this.client.get(`/${RULES_ENDPOINT}/${id}`);

    return data;
  }

  async fetchRuleByDataset(id) {
    const { data } = await this.client.get(`/${RULES_ENDPOINT}/dataset/${id}`);

    return data;
  }

  async toggleChannel(id) {
    const { data } = await this.client.put(`/${CHANNELS_ENDPOINT}/${id}/${TOGGLE}`);

    return data;
  }

  async toggleRule(id) {
    const { data } = await this.client.put(`/${RULES_ENDPOINT}/${id}/${TOGGLE}`);

    return data;
  }

  async updateChannel(id, payload) {
    const { data } = await this.client.put(`/${CHANNELS_ENDPOINT}/${id}`, payload);

    return data;
  }

  async updateEmailPreferences(payload) {
    return await this.client.put(`/${EMAIL_PREFERENCES}`, payload);
  }

  async updateRule(id, payload) {
    const { data } = await this.client.put(`/${RULES_ENDPOINT}/${id}`, payload);

    return data;
  }
}
